import { render, staticRenderFns } from "./hokl_hosm_links.vue?vue&type=template&id=d2665244&scoped=true"
import script from "./hokl_hosm_links.vue?vue&type=script&lang=js"
export * from "./hokl_hosm_links.vue?vue&type=script&lang=js"
import style0 from "./hokl_hosm_links.vue?vue&type=style&index=0&id=d2665244&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2665244",
  null
  
)

export default component.exports